// componentes
import Header from "../components/AdmComponents/Header";
import { Container } from "react-bootstrap";
const AdmLayout = ({ children }) => {
  return (
    <>
      <Header />
      <Container>{children}</Container>
    </>
  );
};

export default AdmLayout;
